<template>
  <div class="mobile-actions-footer">
    <div class="mobile-actions-footer__container">
      <CopyLinkButton />
      <ShareButton />
    </div>
  </div>
</template>

<script setup>
import CopyLinkButton from "@/shared/ui/CopyLinkButton/CopyLinkButton.vue";
import ShareButton from "@/shared/ui/ShareButton/ui/ShareButton.vue";
</script>

<style lang="scss" scoped>
.mobile-actions-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #1a1a1a;
  padding: 30px 25px 40px;
  display: none;
  z-index: 2;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;

  @media (max-width: 768px) {
    display: block;
  }

  &__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 9px;
  }

  :deep(button) {
    width: 100%;
  }
}
</style>

<style lang="scss">
body {
  @media (max-width: 768px) {
    margin-bottom: 119px;
  }
}
</style>
